import { z } from 'src/lib'
import { BaseResponse } from 'src/types'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { getEndpointBySistema } from './httpSistema'
import { FilePutFields } from './file-fields'

const schema = z.object({
    [FilePutFields.CodArchivoTipo]: z.number(),
    [FilePutFields.CodPais]: z.number(),
    [FilePutFields.TieneArchivoFisico]: z.boolean(),
    [FilePutFields.Observaciones]: z.string().optional(),
    [FilePutFields.File]: z.instanceof(File)
})

// TODO: input output types con refine

type SchemaNuevoArchivo = z.infer<typeof schema>

export const postArchivo = (
    idOperacion: number,
    codSistema: number,
    objetoArchivo: SchemaNuevoArchivo
): Promise<BaseResponse> => {
    const endpoint = `${getEndpointBySistema(codSistema)}/${idOperacion}/archivos`

    // TODO: getEndpoint con parametros lo que necesite

    const parsed = schema.safeParse(objetoArchivo)

    if (!parsed.success) {
        console.error('Error de validación:', parsed.error.issues)

        return Promise.reject(new Error('Error de validación.'))
    }

    const formData = new FormData()

    formData.append(FilePutFields.File, objetoArchivo[FilePutFields.File], objetoArchivo[FilePutFields.File].name)
    formData.append(FilePutFields.CodArchivoTipo, parsed.data[FilePutFields.CodArchivoTipo].toString())
    formData.append(FilePutFields.CodPais, parsed.data[FilePutFields.CodPais].toString())
    formData.append(FilePutFields.Observaciones, parsed.data[FilePutFields.Observaciones] ?? '')
    formData.append(FilePutFields.TieneArchivoFisico, 'false')

    return HttpAxiosRequest.post(endpoint, formData)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(error => {
            console.error('Error de red:', error)

            return Promise.reject('Error de red.')
        })
}
